var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelLeaveIlls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 179,
    viewBox: "0 0 423 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342 61C331.059 65.3206 321.786 72.5687 312 79C310.217 80.1715 307.705 80.7194 306 82C305.458 82.4067 305.24 83.3679 305 84C304.754 84.6482 306.336 84.7947 307 85C312.332 86.6478 318.567 86.0656 324 85C329.79 83.8643 334.973 80.8762 340 78C343.251 76.14 345.857 74.0964 348 71C348.927 69.6616 349.266 66.5409 348 65C346.116 62.7064 341.849 60.5269 339 61",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318 75C321.446 74.7721 324.667 73.8825 328 73C328.695 72.8161 330.552 72.7906 331 72C331.22 71.6113 331.017 71.4328 331 71C330.92 68.9509 323.012 70.7534 322 72",
    stroke: "#FB7C51",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312 88C314.317 93.2993 316.736 98.6774 319 104C321.141 109.033 323.387 113.752 325 119C325.395 120.285 325.525 122 327 122C329.486 122 331.546 122.465 334 122C336.084 121.605 338.116 119.906 340 119C345.302 116.451 351.314 115.797 356 112C357.202 111.026 358.426 110.411 359 109C359.41 107.992 360 107.127 360 106C360 103.596 360.504 101.368 360 99C359.2 95.243 356.865 91.3037 355 88C352.491 83.557 349.787 79.7963 348 75",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M325 94C327.617 99.9253 329.979 105.879 332 112",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M335 89C337.396 94.9798 339.701 100.985 342 107",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M343 86C344.677 90.3964 346.101 94.7069 348 99C348.276 99.6238 348.519 99.8283 349 100",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268 80C271.284 80.9205 272.449 81.8567 276 81C279.249 80.2162 282.483 78.0393 285 76C289.25 72.5564 292.683 67.3785 297 64C299.812 61.799 304.187 59.2644 308 60C309.83 60.353 310.635 61.8663 312 63C313.472 64.2225 315.533 65.7717 317 67C317.483 67.4042 317.649 67.4813 318 68",
    stroke: "black",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M313 69C314.468 69.7919 317.243 72.0495 319 71C320.791 69.9302 321 65.8623 321 64",
    stroke: "black",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140 24C140.318 26.3354 140.66 28.6672 141 31",
    stroke: "#FB7C51",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M137 18C134.917 19.3326 135.564 19.5312 134 22C132.751 23.9707 130.784 27.7986 130 30C129.663 30.9473 128.634 32.742 129 34C129.333 35.147 131.078 36.4887 132 37C134.417 38.34 137.298 38.5125 140 39C142.289 39.4129 145.683 40.6246 148 40C152.577 38.7664 152.956 31.4981 151 28C149.545 25.3965 147.208 22.9407 145 21C143.012 19.2523 140.67 18.3832 138 18",
    stroke: "#FB7C51",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M242 20C242.164 22.2228 239.354 24.3647 238 26C237.857 26.1731 236.574 28.0171 237 28C240.979 27.8402 245.018 28 249 28",
    stroke: "#FB7C51",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M237 20C237.16 18.2116 238.483 17.9314 240 18C240.901 18.0408 241 18.1703 241 19",
    stroke: "#FB7C51",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M245 15C239.56 13.2483 230.226 12.9174 227 19C225.45 21.9231 225.313 25.1735 227 28C229.617 32.3838 235.237 34.4913 240 35C242.226 35.2377 244.763 35.0504 247 35C249.363 34.9468 251.42 33.8241 253 32C254.541 30.2206 255.062 28.2313 255 26C254.934 23.6122 253.683 20.6674 252 19C250.311 17.3259 247.378 15.5236 245 15",
    stroke: "#FB7C51",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150 2C128.051 12.1851 107.181 19.5694 83 22C82.1526 22.0852 68.5702 23.4215 70 25C74.5854 30.0624 78.0725 33.6032 81 40C84.2254 47.0477 88.0057 54.4912 90 62C91.6901 68.3633 94.1189 74.4623 95 81C96.4182 91.5238 95 102.41 95 113C95 122.888 94.6673 133.17 96 143C97.1278 151.319 98.8431 159.499 99 168C99.0068 168.366 99.5572 179.363 101 176C103.158 170.97 104.487 168.402 109 165C119.283 157.248 130.324 153.046 143 151C155.459 148.989 166.367 148 179 148C186.115 148 193.887 148.158 201 148C202.88 147.958 202 144.225 202 143",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151 2C153.759 11.47 159.169 19.943 163 29C167.857 40.4804 171.348 51.8537 177 63C180.725 70.3464 182.657 79.4314 186 87C189.35 94.584 191.057 102.955 193 111C194.19 115.926 193.652 121.056 195 126C195.799 128.93 196.843 132.189 198 135C198.913 137.217 200.726 139.011 202 141C202.289 141.451 202.299 142.48 202 143C201.433 143.987 198.1 138.148 198 138",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170 46C170.819 34.9552 169.834 23.0516 169 12C168.929 11.0578 168.484 6.59668 170 5.99999C170.869 5.65782 173.688 5.00314 174 4.99999C179.676 4.94273 185.324 4.99999 191 4.99999C204.954 4.99999 219.047 4.99999 233 4.99999C239.699 4.99999 247.299 4.28247 254 4.99999C259.954 5.63749 260.336 6.83431 261 13C261.54 18.0099 263.43 22.9607 264 28C264.783 34.9153 264 42.0545 264 49C264 69.3705 264 89.6295 264 110C264 117.942 264 126.058 264 134C264 135.518 263.017 137.732 264 139C265.717 141.216 265.611 145.378 266 148C266.089 148.598 268.309 155.545 266 154C261.407 150.926 254.258 149.514 249 148C241.572 145.861 235.691 145 228 145C220.802 145 213.198 145 206 145C202.759 145 198.909 146.46 196 145",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102 50C102.266 54.1425 103.962 62 109 62C110.455 62 114 61.9526 114 60C114 55.5746 112.271 52.2005 111 48C110.431 46.1191 101.093 49.1107 100 50",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107 83C124.278 78.0242 141.128 73.8774 159 72C161.449 71.7428 164.574 71.9818 167 71",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108 101C113.101 101 118.316 99.9673 123 98",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122 139C135.333 134.739 148.113 134 162 134",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M182 27C182 32.2378 182 37.7622 182 43C182 43.777 182.165 46.164 183 47C184.224 48.2255 188.443 48 190 48C190.862 48 194.298 48.8033 195 48C196.837 45.8974 195.284 38.2314 195 36C194.495 32.0298 195.02 27.0241 192 24C190.984 22.9828 185.123 25.4376 184 26",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180 68H247",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M185 81C192.002 81.317 199 81.6591 206 82",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M194 121C209.973 121 227.549 118.263 243 123",
    stroke: "#FB7C51",
    strokeWidth: 3.35686,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2 161C13.0798 158.345 22.8509 152.588 34 150C43.1005 147.888 54.093 147.186 63 150C70.5293 152.379 78.1982 156.69 86 158C90.2938 158.721 94.6529 158 99 158",
    stroke: "#FB7C51",
    strokeWidth: 2.97067,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M421 150C400.772 144.887 380.048 136.785 359 136C348.327 135.602 336.588 135.524 326 137C320.711 137.737 316.243 140.473 311 141C304.948 141.609 299.037 140.141 293 141C285.077 142.128 277.029 142 269 142",
    stroke: "#FB7C51",
    strokeWidth: 2.97067,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelLeaveIlls);
export default __webpack_public_path__ + "static/media/cancelLeaveIlls.a9c8b9ecf520eb2a91fe567c380ba054.svg";
export { ForwardRef as ReactComponent };